import './sentry';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { CssBaseline } from '@mui/material';

import router from '@/router';
import DichteThemeProvider from '@/theme/DichteThemeProvider';

import reportWebVitals from '@/reportWebVitals';
import Session from '@/components/utility/Session';

import ToastContainer from '@/components/ui/ToastContainer/ToastContainer';
import { Sentry } from '@/sentry';

import '@/services/i18n';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
          <h2>Etwas ist schiefgelaufen.</h2>
          <p>Bitte die Seite neu laden. Wenn der Fehler bleibt: melden.</p>
        </div>
      }
    >
      <DichteThemeProvider>
        <CssBaseline />
        <ToastContainer />
        <Session>
          <RouterProvider router={router} />
        </Session>
      </DichteThemeProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
